import{jsxs as d,jsx as i}from"react/jsx-runtime";import r from"styled-components";import{Modal as f}from"../Modal/index.js";import h from"../../theme.js";import{TinyTitleBold as c}from"../../typography/Heading/index.js";import"react";import"react-dom";import"react-transition-group";import"../../icons/components/CloseIcon.js";import"../../utils/utils.js";import"../FocusTrap.js";import"../../shared/media-queries.js";const g=r(c)`
  font-weight: ${h.typography.fontAlternativeRegularWeight};
  margin: 0;
`,w=r.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  overflow-x: hidden;
`,e=({isOpen:n,title:o,children:l,actions:t,onClose:m,withPortal:p,withCloseIcon:s=!0,...a})=>d(f,{onClose:m,withPortal:p,isOpen:n,withCloseIcon:s,...a,children:[typeof o=="string"?i(g,{children:o}):o,i("div",{children:l}),t&&i(w,{children:t})]});export{e as Dialog,e as default};
